// Press coverage of Kudu Humanities, newest first. This is the single edit point
// for the press grid: to add or remove an article, edit this array (and add a logo
// to src/images/press/ when a new publication appears). Rendered by PressCards on
// both /humanities and /press.

import chronicleLogo from '@/images/press/chronicle.jpg';
import dailyBruinLogo from '@/images/press/daily_bruin.png';
import globalWomanLeaderLogo from '@/images/press/global_woman_leader.jpg';
import higherEdGeekLogo from '@/images/press/higher_ed_geek.jpg';
import insideHigherEdLogo from '@/images/press/inside_higher_ed.jpg';
import laistLogo from '@/images/press/laist.jpg';
import spectrumNewsLogo from '@/images/press/spectrum_news.png';
import uclaNewsroomLogo from '@/images/press/ucla_newsroom.jpg';

export interface PressArticle {
  date: string;
  id: number;
  logo: string;
  publication: string;
  title: string;
  url: string;
}

export const pressArticles: PressArticle[] = [
  {
    date: 'June 2026',
    id: 1,
    logo: globalWomanLeaderLogo,
    publication: 'Global Woman Leader',
    title: 'Building the Future of Context-Aware Education',
    url: 'https://www.globalwomanleader.com/leader/elizabeth-m-landers-building-the-future-of-context-aware-education-vid-1682.html',
  },
  {
    date: 'April 30, 2026',
    id: 2,
    logo: spectrumNewsLogo,
    publication: 'Spectrum News',
    title: 'AI-Generated Coursework, Textbooks Hit College Campuses',
    url: 'https://spectrumnews1.com/ca/la/campus-report/2026/04/30/the-campus-report--artificial-intelligence',
  },
  {
    date: 'February 3, 2026',
    id: 3,
    logo: insideHigherEdLogo,
    publication: 'Inside Higher Ed',
    title: 'Reflections on the Value of an AI-Assisted Textbook',
    url: 'https://www.insidehighered.com/news/tech-innovation/artificial-intelligence/2026/02/03/reflections-value-ai-assisted-textbook',
  },
  {
    date: 'November 4, 2025',
    id: 4,
    logo: chronicleLogo,
    publication: 'Chronicle of Higher Education',
    title: 'AI Has Joined the Faculty',
    url: 'https://www.chronicle.com/article/ai-has-joined-the-faculty',
  },
  {
    date: 'April 15, 2025',
    id: 5,
    logo: higherEdGeekLogo,
    publication: 'Higher Ed Geek Podcast',
    title: 'Building the Next-Gen AI-Enhanced College Textbook at UCLA',
    url: 'https://www.enrollify.org/episodes/bonus-live-from-the-ai-show-building-the-next-gen-ai-enhanced-college-textbook-at-ucla',
  },
  {
    date: 'March 14, 2025',
    id: 6,
    logo: dailyBruinLogo,
    publication: 'Daily Bruin Magazine',
    title: 'Generative AI, the New Teacher’s Pet?',
    url: 'https://dailybruin.com/2025/03/14/generative-ai-the-new-teachers-pet',
  },
  {
    date: 'March 2, 2025',
    id: 7,
    logo: dailyBruinLogo,
    publication: 'Daily Bruin',
    title: 'UCLA Professors Strive to Make Course Materials Accessible, Introduce AI Textbooks',
    url: 'https://dailybruin.com/2025/03/02/ucla-professors-strive-to-make-course-materials-accessible-introduce-ai-textbooks',
  },
  {
    date: 'February 12, 2025',
    id: 8,
    logo: spectrumNewsLogo,
    publication: 'Spectrum News',
    title: 'UCLA Professor Welcoming the Help of AI to Create Textbook',
    url: 'https://spectrumnews1.com/ca/southern-california/education/2025/02/12/ai-ucla-textbook',
  },
  {
    date: 'February 4, 2025',
    id: 9,
    logo: laistLogo,
    publication: 'LAist / NPR 88.9',
    title: 'Instead of Banning AI, This UCLA Literature Class Embraces It',
    url: 'https://laist.com/news/education/ucla-humanities-courses-artificial-intelligence-chatgpt-kudu',
  },
  {
    date: 'December 13, 2024',
    id: 10,
    logo: insideHigherEdLogo,
    publication: 'Inside Higher Ed',
    title: 'An AI-Assisted Textbook at UCLA Has Some Academics Worried',
    url: 'https://www.insidehighered.com/news/faculty-issues/learning-assessment/2024/12/13/ai-assisted-textbook-ucla-has-some-academics',
  },
  {
    date: 'December 4, 2024',
    id: 11,
    logo: uclaNewsroomLogo,
    publication: 'UCLA Newsroom',
    title: 'Comparative Lit Class Will Be First in Humanities Division to Use UCLA-Developed AI System',
    url: 'https://newsroom.ucla.edu/stories/comparative-literature-zrinka-stahuljak-artificial-intelligence',
  },
];
